import {Component, OnInit} from '@angular/core';
import {Aktivitet} from './models/aktivitet';
import {AktiviteterService} from './aktiviteter.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-aktivitet-list',
    templateUrl: './aktiviteter.component.html',
    styles: ['tr.old td { color:gray; }']
})
export class AktivitetListComponent implements OnInit {
    aktiviteter: Aktivitet[];
    nextModerloge: Aktivitet;
    lastModerloge: Aktivitet;
    nextDotterloge: Aktivitet;
    lastDotterloge: Aktivitet;
    loadtext = 'Laddar...';

    constructor(private aktiviteterService: AktiviteterService, private router: Router) {
    }

    ngOnInit(): void {
        this.aktiviteterService.getAktiviteter().then(result => this.afterInit(result));
    }

    afterInit(s: Aktivitet[]): void {
        this.aktiviteter = s;
        this.loadtext = null;
        this.setShortcuts();
    }

    gotoAktivitet(aktiviteter_id): void {
        this.router.navigate(['/tilldelning', aktiviteter_id]);
    }

    trcolor(date: string) {
        return (new Date() > new Date(date)) ? 'old' : '';
    }

    setShortcuts(): void {
        const date = new Date().toISOString().slice(0, 10);
        const len = this.aktiviteter.length;
        console.log(date);
        console.log('Antal aktiviteter: ' + len);
        for (let i = 0; i < len; i++) {
            const a = this.aktiviteter[i];
            if (a.type === 1 && a.date >= date) {
                if (this.nextModerloge == null) {
                    this.nextModerloge = a;
                }
                if (a.date < this.nextModerloge.date) {
                    this.nextModerloge = a;
                }
            }
            if (a.type === 1 && a.date < date) {
                if (this.lastModerloge == null) {
                    this.lastModerloge = a;
                }
                if (a.date > this.lastModerloge.date) {
                    this.lastModerloge = a;
                }
            }
            if (a.type === 2 && a.date >= date) {
                if (this.nextDotterloge == null) {
                    this.nextDotterloge = a;
                }
                if (a.date < this.nextDotterloge.date) {
                    this.nextDotterloge = a;
                }
            }
            if (a.type === 2 && a.date < date) {
                if (this.lastDotterloge == null) {
                    this.lastDotterloge = a;
                }
                if (a.date > this.lastDotterloge.date) {
                    this.lastDotterloge = a;
                }
            }
        }
        console.log('Nästa moderlogekapitel: ' + this.nextModerloge.title);
    }
}




// WEBPACK FOOTER //
// /builds/johannes-jonsson/consmin-app/src/app/aktiviteter.component.ts